import * as React from 'react';


import { useFormikContext } from 'formik';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';
import type { TextFieldProps } from 'v2/components/Shared/FormFields/TextFormField';
import { Icon } from '@eduzz/ui-antd-theme';

type InputProps = Omit<TextFieldProps, 'form' | 'field' | 'meta'> & {
  name: string;
  select?: boolean;
  children?: React.ReactNode;
  inputProps?: Record<string, unknown>;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  minRows?: number;
};

const rootClassName = [
  '[&_label]:text-content-subtitle [&_label]:text-base [&_label]:font-semibold [&_label]:font-sans',
  '[&_label]:h-1.75 [&_label]:[transform:translate(20px)_scale(0.75)]! [&_label]:bg-surface-default',
  '[&_[role=button]]:border-0',
  '[&_input]:text-content-subtitle [&_input]:py-3.25 [&_input]:px-3.5 [&_input]:font-sans [&_input]:bg-surface-default [&_input]:text-sm [&_input]:pl-5',
  '[&_input::placeholder]:text-content-subtitle',
  '[&>div>div]:text-content-subtitle [&>div>div]:py-3.25 [&>div>div]:px-3.5 [&>div>div]:font-sans [&>div>div]:bg-surface-default [&>div>div]:text-sm [&>div>div]:pl-5',
  '[&>div]:bg-surface-default',
  '[&_fieldset]:border-outline-default [&_fieldset_legend]:ml-1.5 [&_fieldset_legend]:text-[[0.8rem]'
].join(' ');

const selectMenuListClassName = [
  '[&>li]:leading-3.5 [&>li]:py-2.5 [&>li]:px-4 [&>li]:font-sans',
  '[&>li:hover]:bg-(--uizz-antd-color-fill-quaternary)',
  '[&>li[aria-selected=true]]:bg-(--uizz-antd-color-fill-quaternary) [&>li[aria-selected=true]]:text-primary'
].join(' ');

function Input({ name, helperText, ...props }: InputProps) {
  const form = useFormikContext();

  return (
    <TextFormField
      id={name}
      form={form}
      field={form.getFieldProps(name)}
      meta={form.getFieldMeta(name)}
      className={rootClassName}
      helperText={typeof helperText === 'string' ? <span className='text-primary'>{helperText}</span> : helperText}
      variant='outlined'
      inputProps={{
        ['data-testid']: name
      }}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        IconComponent: () => (
          <Icon.ChevronDown size={20} className='text-content-subtitle pointer-events-none absolute top-1/2 right-4 -translate-y-1/2 text-xl'  />
        ),
        MenuProps: {
          classes: {
            paper: 'text-content-body text-sm max-h-[calc(100%-500px)]',
            list: selectMenuListClassName
          }
        }
      }}
      FormHelperTextProps={{
        className: 'mx-0 mt-2 font-sans text-[[0.625rem]'
      }}
      fullWidth
      {...props}
    />
  );
}

export { Input };
